module.exports = __webpack_public_path__ + "static/media/219RO.6892b3e3.jpg";